import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [usuario, setUsuario] = useState(() => {
        try {
            const raw = localStorage.getItem('chucho_usuario');
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    });
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('chucho_token');
        if (!token) { setCargando(false); return; }
        api.get('/auth/yo')
            .then(res => {
                setUsuario(res.data.usuario);
                localStorage.setItem('chucho_usuario', JSON.stringify(res.data.usuario));
            })
            .catch(() => {
                localStorage.removeItem('chucho_token');
                localStorage.removeItem('chucho_usuario');
                setUsuario(null);
            })
            .finally(() => setCargando(false));
    }, []);

    const login = async (correo, contrasena) => {
        const res = await api.post('/auth/login', { correo, contrasena });
        localStorage.setItem('chucho_token', res.data.token);
        localStorage.setItem('chucho_usuario', JSON.stringify(res.data.usuario));
        setUsuario(res.data.usuario);
        return res.data;
    };

    const logout = async () => {
        try { await api.post('/auth/logout'); } catch {}
        localStorage.removeItem('chucho_token');
        localStorage.removeItem('chucho_usuario');
        setUsuario(null);
    };

    const actualizarUsuario = (cambios) => {
        setUsuario(prev => {
            const nuevo = { ...prev, ...cambios };
            localStorage.setItem('chucho_usuario', JSON.stringify(nuevo));
            return nuevo;
        });
    };

    return (
        <AuthContext.Provider value={{ usuario, cargando, login, logout, actualizarUsuario }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
